export const USER_TYPES = [
    {
        data: 'SCHOOL_ADMIN',
        view: 'Super Admin',
        file: 'superadmin'
    },
    {
        data: 'SCHOOL_DIRECTOR',
        view: 'Manager',
        file: 'manager'
    },
    {
        data: 'SCHOOL_COORDINATOR',
        view: 'Coordinator',
        file: 'coordinator'
    },
    {
        data: 'SCHOOL_INSTRUCTOR',
        view: 'Instructor',
        file: 'instructor'
    }
];

export const SCHOOL_ADMIN = USER_TYPES[0].data;
export const SCHOOL_DIRECTOR = USER_TYPES[1].data;
export const SCHOOL_COORDINATOR = USER_TYPES[2].data;
export const SCHOOL_INSTRUCTOR = USER_TYPES[3].data;


// WEBPACK FOOTER //
// ./src/constants/user-types.js